/* eslint-disable indent */
import React from "react";
import styles from "../stylesER.module.scss";

export const CostosFijosTable = ({
  modoCombinado,
  costosFijosCollapsed,
  setCostosFijosCollapsed,
  costosFijosMensualesCombinados,
  monthsToShow,
  sumarCostosFijosMes,
  formatCurrency,
  porcentajeSobreFacturacion,
  costosFijosYTD,
  rrhhCollapsed,
  setRrhhCollapsed,
  isEmpleadosRRHHLoading,
  rrhhMensualConBeneficios,
  empleadosRRHH,
  getSueldoBaseVigente,
  selectedYear,
  pais,
  puedeEditar,
  nombresCostosFijos,
  camposCostosFijos,
  meses,
  rawCostosFijos,
  costosFijosData,
  getProjectedCostoFijo,
  verEnDolares,
  getDolarValue,
  dolarMensual,
  localString,
  openEditModal,
  verUltimos12Meses,
  costosFijosMensualWindowed,
}) => (
  <>
    {/* === SECCIÓN COSTOS FIJOS === */}
    <tr
      className={styles.totalCostosRow}
      onClick={() => !modoCombinado && setCostosFijosCollapsed(!costosFijosCollapsed)}
      style={{ cursor: modoCombinado ? "default" : "pointer", userSelect: "none" }}
    >
      <td className={styles.conceptCell}>
        Costos Fijos {!modoCombinado && !verUltimos12Meses && costosFijosCollapsed ? ">" : ""}
      </td>
      {Array(12)
        .fill(0)
        .map((_, i) => {
          if (i >= monthsToShow) return <td key={i}>-</td>;

          // En modo combinado usar valores ya en USD; en modo ventana usar array pre-computado
          const totalMes = modoCombinado
            ? costosFijosMensualesCombinados[i]
            : verUltimos12Meses
              ? costosFijosMensualWindowed[i] || 0
              : sumarCostosFijosMes(i);

          return (
            <td key={i} className="text-end font-weight-bold">
              {formatCurrency(totalMes, i, null, modoCombinado)}
            </td>
          );
        })}
      <td className={styles.totalCell}>
        {modoCombinado
          ? formatCurrency(
              costosFijosMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0),
              null,
              null,
              true
            )
          : formatCurrency(
              costosFijosYTD,
              null,
              verUltimos12Meses
                ? costosFijosMensualWindowed
                : Array.from({ length: 12 }, (_, i) => (i < monthsToShow ? sumarCostosFijosMes(i) : 0))
            )}{" "}
        |{" "}
        {porcentajeSobreFacturacion(
          modoCombinado
            ? costosFijosMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0)
            : costosFijosYTD
        )}
      </td>
    </tr>

    {!modoCombinado && !costosFijosCollapsed && (
      <>
        {/* NUEVA SECCIÓN RRHH */}
        <tr
          onClick={() => {
            setRrhhCollapsed(!rrhhCollapsed);
          }}
          style={{ cursor: "pointer", userSelect: "none" }}
        >
          <td className={styles.conceptCell}>
            RRHH {rrhhCollapsed ? ">" : "∨"}
            {isEmpleadosRRHHLoading && " (cargando...)"}
          </td>
          {Array(12)
            .fill(0)
            .map((_, i) => (
              <td key={i} className="text-end font-weight-bold">
                {i < monthsToShow ? formatCurrency(rrhhMensualConBeneficios[i], i) : "-"}
              </td>
            ))}
          <td className={styles.totalCell}>
            {formatCurrency(
              rrhhMensualConBeneficios.slice(0, monthsToShow).reduce((a, b) => a + b, 0),
              null,
              rrhhMensualConBeneficios
            )}{" "}
            | {porcentajeSobreFacturacion(rrhhMensualConBeneficios.slice(0, monthsToShow).reduce((a, b) => a + b, 0))}
          </td>
        </tr>
        {!rrhhCollapsed && (
          <>
            {empleadosRRHH.map((emp) => {
              const tieneSueldoEnYTD = Array(monthsToShow)
                .fill(0)
                .some((_, i) => getSueldoBaseVigente(emp, i) > 0);
              // También mostrar si tiene egreso en el año (aunque no tenga sueldo)
              const tieneEgresoEnYTD =
                emp.egreso_fecha &&
                emp.egreso_monto &&
                new Date(emp.egreso_fecha).getFullYear() === selectedYear &&
                new Date(emp.egreso_fecha).getMonth() < monthsToShow;
              if (!tieneSueldoEnYTD && !tieneEgresoEnYTD) return null;

              return (
                <tr key={emp.id} className={styles.rrhhSubrow}>
                  <td className={styles.conceptCell} style={{ paddingLeft: "30px" }}>
                    {emp.nombre} {emp.apellido}
                  </td>
                  {Array(12)
                    .fill(0)
                    .map((_, i) => {
                      const valor = i < monthsToShow ? getSueldoBaseVigente(emp, i) : 0;
                      const tieneEgreso =
                        emp.egreso_fecha &&
                        emp.egreso_monto &&
                        new Date(emp.egreso_fecha).getFullYear() === selectedYear &&
                        new Date(emp.egreso_fecha).getMonth() === i;
                      return (
                        <td key={i} className="text-end">
                          {valor > 0 && formatCurrency(valor, i)}
                          {valor === 0 && !tieneEgreso && "-"}
                          {tieneEgreso && (
                            <div style={{ color: "#dc2626", fontWeight: "600" }}>
                              {formatCurrency(Number(emp.egreso_monto), i)}
                            </div>
                          )}
                        </td>
                      );
                    })}
                  <td className={styles.totalCell}>
                    {formatCurrency(
                      Array(monthsToShow)
                        .fill(0)
                        .reduce((sum, _, i) => sum + getSueldoBaseVigente(emp, i), 0),
                      null,
                      Array.from({ length: 12 }, (_, i) => getSueldoBaseVigente(emp, i))
                    )}
                  </td>
                </tr>
              );
            })}
            {/* CTS y Gratificaciones */}
            {pais === "Perú" && (
              <tr className={styles.rrhhSubrow}>
                <td className={styles.conceptCell} style={{ paddingLeft: "30px", fontStyle: "italic" }}>
                  CTS y Gratificaciones
                </td>
                {Array(12)
                  .fill(0)
                  .map((_, i) => {
                    // Solo mostrar meses transcurridos, no futuros
                    if (i >= monthsToShow) {
                      return (
                        <td key={i} className="text-end">
                          -
                        </td>
                      );
                    }
                    const mes = i + 1;
                    let valor = 0;

                    // Gratificación de julio (paga en junio)
                    if (mes === 6) {
                      valor += empleadosRRHH.reduce((sum, emp) => {
                        const sueldo = getSueldoBaseVigente(emp, 5);
                        return sum + (sueldo > 0 ? sueldo : 0);
                      }, 0);
                    }

                    // Gratificación de diciembre (paga en diciembre)
                    if (mes === 12) {
                      valor += empleadosRRHH.reduce((sum, emp) => {
                        const sueldo = getSueldoBaseVigente(emp, 11);
                        return sum + (sueldo > 0 ? sueldo : 0);
                      }, 0);
                    }

                    // CTS mayo (por semestre nov-abr)
                    if (mes === 5) {
                      valor += empleadosRRHH.reduce((sum, emp) => {
                        const sueldo = getSueldoBaseVigente(emp, 4);
                        return sum + (sueldo > 0 ? sueldo : 0);
                      }, 0);
                    }

                    // CTS noviembre (por semestre may-oct)
                    if (mes === 11) {
                      valor += empleadosRRHH.reduce((sum, emp) => {
                        const sueldo = getSueldoBaseVigente(emp, 10);
                        return sum + (sueldo > 0 ? sueldo : 0);
                      }, 0);
                    }

                    return (
                      <td key={i} className="text-end">
                        {valor > 0 ? formatCurrency(valor, i) : "-"}
                      </td>
                    );
                  })}
                <td className={styles.totalCell}>
                  {formatCurrency(
                    Array(monthsToShow)
                      .fill(0)
                      .reduce((sum, _, i) => {
                        const mes = i + 1;
                        let valor = 0;
                        if (mes === 5 || mes === 6 || mes === 11 || mes === 12) {
                          valor = empleadosRRHH.reduce((s, emp) => {
                            const sueldo = getSueldoBaseVigente(emp, i);
                            return s + (sueldo > 0 ? sueldo : 0);
                          }, 0);
                        }
                        return sum + valor;
                      }, 0),
                    null,
                    Array.from({ length: 12 }, (_, i) => {
                      const mes = i + 1;
                      if (mes === 5 || mes === 6 || mes === 11 || mes === 12) {
                        return empleadosRRHH.reduce((s, emp) => {
                          const sueldo = getSueldoBaseVigente(emp, i);
                          return s + (sueldo > 0 ? sueldo : 0);
                        }, 0);
                      }
                      return 0;
                    })
                  )}
                </td>
              </tr>
            )}
            {/* Gratificaciones Chile */}
            {pais === "Chile" && (
              <tr className={styles.rrhhSubrow}>
                <td className={styles.conceptCell} style={{ paddingLeft: "30px", fontStyle: "italic" }}>
                  Gratificaciones
                </td>
                {Array(12)
                  .fill(0)
                  .map((_, i) => {
                    if (i >= monthsToShow) {
                      return (
                        <td key={i} className="text-end">
                          -
                        </td>
                      );
                    }
                    // Gratificación Chile: IMM=500000, tope 4.75*IMM/12
                    const IMM = 500000;
                    const gratMax = (4.75 * IMM) / 12;
                    const valor = empleadosRRHH.reduce((sum, emp) => {
                      const sueldo = getSueldoBaseVigente(emp, i);
                      if (sueldo > 0) {
                        return sum + Math.round(Math.min((sueldo * 0.25) / 12, gratMax));
                      }
                      return sum;
                    }, 0);
                    return (
                      <td key={i} className="text-end">
                        {valor > 0 ? formatCurrency(valor, i) : "-"}
                      </td>
                    );
                  })}
                <td className={styles.totalCell}>
                  {formatCurrency(
                    Array(monthsToShow)
                      .fill(0)
                      .reduce((sum, _, i) => {
                        const IMM = 500000;
                        const gratMax = (4.75 * IMM) / 12;
                        return (
                          sum +
                          empleadosRRHH.reduce((s, emp) => {
                            const sueldo = getSueldoBaseVigente(emp, i);
                            if (sueldo > 0) {
                              return s + Math.round(Math.min((sueldo * 0.25) / 12, gratMax));
                            }
                            return s;
                          }, 0)
                        );
                      }, 0)
                  )}
                </td>
              </tr>
            )}
          </>
        )}
        {nombresCostosFijos.map((concepto, index) => {
          if (concepto === "RRHH") return null;
          const campo = camposCostosFijos[index];
          const esAsesoriaExterna = campo === "asesoria_externa";

          return (
            <tr key={concepto}>
              <td className={styles.conceptCell}>{concepto}</td>
              {meses.map((_, i) => {
                const registroExiste = rawCostosFijos?.some(
                  (r) => Number(r.mes) === i + 1 && r[campo] !== undefined && r[campo] !== null
                );
                const valorReal = costosFijosData[i]?.[campo];
                const esProyectado = i < monthsToShow && !registroExiste;
                const valor = esProyectado ? getProjectedCostoFijo(campo, i) : (valorReal ?? 0);

                // Caso especial: Asesoría externa en modo USD
                if (esAsesoriaExterna && verEnDolares && i < monthsToShow) {
                  const usdOriginal = costosFijosData[i]?.asesoria_externa_usd;
                  const fechaFactura = costosFijosData[i]?.asesoria_externa_fecha;

                  let valorUSD = 0;

                  if (usdOriginal && usdOriginal > 0) {
                    // Caso 1: Tenemos USD guardado → usarlo directo
                    valorUSD = usdOriginal;
                  } else if (valor > 0 && fechaFactura) {
                    // Caso 2: Tenemos fecha → convertir con dólar exacto de esa fecha
                    const dolarExacto = getDolarValue(fechaFactura);
                    valorUSD = valor / dolarExacto;
                  } else if (valor > 0 && dolarMensual[i]) {
                    // Caso 3: Fallback → usar dólar del mes
                    valorUSD = valor / dolarMensual[i];
                  }

                  const locale = localString(pais);
                  const formatted = Math.round(valorUSD).toLocaleString(locale, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  });

                  return (
                    <td key={i}>
                      <div
                        onClick={() => {
                          if (puedeEditar) openEditModal(concepto, i, campo);
                        }}
                        style={{
                          cursor: puedeEditar ? "pointer" : "default",
                          backgroundColor: esProyectado ? "#fff9c4" : "transparent",
                        }}
                      >
                        US$ {formatted}
                      </div>
                    </td>
                  );
                }

                return (
                  <td key={i}>
                    <div
                      onClick={() => {
                        if (i < monthsToShow && puedeEditar) openEditModal(concepto, i, campo);
                      }}
                      style={{
                        cursor: i < monthsToShow && puedeEditar ? "pointer" : "default",
                        backgroundColor: esProyectado ? "#fff9c4" : "transparent",
                      }}
                    >
                      {i < monthsToShow ? formatCurrency(valor, i) : "-"}
                    </div>
                  </td>
                );
              })}
              <td className={styles.totalCell}>
                {/* Caso especial YTD: Asesoría externa en modo USD */}
                {esAsesoriaExterna && verEnDolares
                  ? (() => {
                      let totalUsd = 0;
                      for (let i = 0; i < monthsToShow; i++) {
                        const usdOriginal = costosFijosData[i]?.asesoria_externa_usd;
                        const fechaFactura = costosFijosData[i]?.asesoria_externa_fecha;
                        const valorLocal = costosFijosData[i]?.asesoria_externa || 0;

                        if (usdOriginal && usdOriginal > 0) {
                          totalUsd += usdOriginal;
                        } else if (valorLocal > 0 && fechaFactura) {
                          const dolarExacto = getDolarValue(fechaFactura);
                          totalUsd += valorLocal / dolarExacto;
                        } else if (valorLocal > 0 && dolarMensual[i]) {
                          totalUsd += valorLocal / dolarMensual[i];
                        }
                      }
                      const locale = localString(pais);
                      const formatted = Math.round(totalUsd).toLocaleString(locale, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      });
                      return `US$ ${formatted}`;
                    })()
                  : formatCurrency(
                      costosFijosData.slice(0, monthsToShow).reduce((sum, row) => sum + (row?.[campo] || 0), 0),
                      null,
                      costosFijosData.map((row) => row?.[campo] || 0)
                    )}
              </td>
            </tr>
          );
        })}
      </>
    )}
  </>
);
